import QualityCheckTabs from "../../features/qualitycheck/page/QualityCheckTabs"
import { ScheduleChecklists } from "../../features/checklist/component/ChecklistScheduleCalendar"
import { Profile } from "../../features/profile/page/Profile"
import React from "react"
import Checklists from "../../features/checklist/page/ChecklistList"
import ChecklistDetail from "../../features/checklist/page/ChecklistDetail"
import QualityCheckDetail from "../../features/qualitycheck/page/QualityCheckDetail"
import { InstructionalVideoDetail } from "../../features/instructionalvideo/page/InstructionalVideoDetail"
import WatchLogs from "../../features/instructionalvideo/page/WatchLogs"
import { InstructionalVideos } from "../../features/instructionalvideo/page/InstructionalVideos"
import { QualityCheckSummary } from "../../features/qualitycheck/page/QualityCheckSummary"
import { UserRole } from "../../features/auth/model/userRole"
import Dashboard from "../../features/dashboard/page/Dashboard"
import About from "../../features/profile/page/About"
import IconChart from "../components/icon/IconChart"
import IconFile from "../components/icon/IconFile"
import IconQualityCheck from "../components/icon/IconQualityCheck"
import IconVideo from "../components/icon/IconVideo"
import IconWatchStatistic from "../components/icon/IconWatchStatistic"
import IconAbout from "../components/icon/IconAbout"

export interface RouteItem {
    path: string
    element: React.ComponentType
    breadcrumb: string
    allowedRoles?: UserRole[]
    sidebarItem?: {
        text: string
        icon: React.ReactNode
    }
}

export const routes: RouteItem[] = [
    {
        path: "/dashboard",
        element: Dashboard,
        breadcrumb: "Dashboard",
        sidebarItem: {
            text: "Dashboard",
            icon: <IconChart size="small" />
        }
    },
    {
        path: "/checklists",
        element: Checklists,
        breadcrumb: "Checklists",
        sidebarItem: {
            text: "Checklists",
            icon: <IconFile size="small" />
        }
    },
    {
        path: "/checklists/new",
        element: ChecklistDetail,
        breadcrumb: "New",
    },
    {
        path: "/checklists/:id",
        element: ChecklistDetail,
        breadcrumb: "Details",
    },
    {
        path: "/qualitychecks",
        element: QualityCheckTabs,
        breadcrumb: "Quality Checks",
        sidebarItem: {
            text: "Quality Checks",
            icon: <IconQualityCheck size="small" />
        }
    },
    {
        path: "/instructional-videos",
        element: InstructionalVideos,
        breadcrumb: "Instructional Videos",
        sidebarItem: {
            text: "Instructional Videos",
            icon: <IconVideo size="small" />
        },
        allowedRoles: [UserRole.VideoViewer]
    },
    {
        path: "/instructional-videos/:id",
        element: InstructionalVideoDetail,
        breadcrumb: "Details",
        allowedRoles: [UserRole.VideoViewer]
    },
    {
        path: "/watch-logs",
        element: WatchLogs,
        breadcrumb: "Watch Statistics",
        allowedRoles: [UserRole.VideoManager],
        sidebarItem: {
            text: "Watch Statistics",
            icon: <IconWatchStatistic size="small" />
        }
    },
    {
        path: "/qualitychecks/:id",
        element: QualityCheckDetail,
        breadcrumb: "Details",
    },
    {
        path: "/qualitychecks/:id/summary",
        element: QualityCheckSummary,
        breadcrumb: "Summary"
    },
    {
        path: "/about",
        element: About,
        breadcrumb: "About",
        sidebarItem: {
            text: "About",
            icon: <IconAbout size="small" />
        }
    },
    {
        path: "/schedulechecklists",
        element: ScheduleChecklists,
        breadcrumb: "Schedule",
    },
    {
        path: "/profile",
        element: Profile,
        breadcrumb: "Profile",
    }
]
